import React from 'react'

const UpperContentDesign = () => (
  <style type="text/css">
    {
      `.content {
        border-bottom: dashed 2px #646464;
        text-align: center;
        width: 612px;
        margin: auto;
      }
      .content > div > svg {
        height: 65px;
        width: 290px;
      }
      .content > div:nth-child(2) {
        display: grid;
        grid-template-column: 1fr;
        row-gap: 20px;
      }
      .content > div:nth-child(2) > span:first-child {
        color: rgb(51, 51, 51);
        font-family: 'Roboto';
        font-size: 20px;
        font-weight: normal;
        letter-spacing: 0px;
        line-height: 28px;
        text-align: center;
        padding-botto
      }
      .content > div:nth-child(2) > span:last-child {
        color: rgb(51, 51, 51);
        font-family: 'Roboto';
        font-size: 14px;
        font-weight: bold;
        letter-spacing: 0px;
        line-height: 20px;
        text-align: center;
      }
      .content > div:nth-child(3) {
        padding: 19px 43px;width: 320px;
        margin: 10px auto 20px;
        border: solid 2px #333333;
      }

      .content > div:nth-child(4) > span {
        color: rgb(51, 51, 51);
        font-family: 'Roboto';
        font-size: 14px;
        font-weight: bold;
        letter-spacing: 0px;
        line-height: 20px;
        text-align: center;
      }
      .content > div:nth-child(5) {
        padding: 19px 43px;width: 320px;
        margin: 10px auto 20px;
        border: solid 2px #333333;
      }
      `
    }
  </style>
)

export default UpperContentDesign
